import { useCallback, useState } from 'react';

import { MAX_RECENT_SEARCHES, SearchCategory } from '../../UniversalSearch.constants';

import { persistRecentItems, readRecentItems } from './utils';

const useRecentSearches = () => {
  const [recentItems, setRecentItems] = useState(readRecentItems);

  const addRecentItem = useCallback(item => {
    if (item.category === SearchCategory.NAVIGATION) {
      return;
    }

    setRecentItems(prev => {
      const filtered = prev.filter(stored => stored.id !== item.id);
      const updated = [
        { id: item.id, label: item.label, category: item.category, breadcrumb: item.breadcrumb },
        ...filtered,
      ].slice(0, MAX_RECENT_SEARCHES);

      persistRecentItems(updated);

      return updated;
    });
  }, []);

  const clearRecentItems = useCallback(() => {
    setRecentItems([]);
    persistRecentItems([]);
  }, []);

  return { recentItems, addRecentItem, clearRecentItems };
};

export default useRecentSearches;
